// components/PasswordInput.js
import React from "react";
import { Input } from "antd";
import "./PasswordInput.scss";
import { Field, ErrorMessage } from "formik";

const PasswordInput = ({ name, label }) => {
  return (
    <div className="mainWrapperInput">
      {/* style={{ marginBottom: "15px" }} */}
      {/* <label htmlFor={name}>{label}</label> */}
      <Field name={name}>
        {({ field }) => (
          <Input.Password
            {...field}
            id={name}
            placeholder="Enter your password"
            visibilityToggle={true} // this shows the eye icon
          />
        )}
      </Field>
      <ErrorMessage
        name={name}
        className="errorMsg"
        component="div"
        style={{ color: "red", display: "flex" }}
      />
    </div>
  );
};

export default PasswordInput;
